import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedUserRole: cacheLs.get_user_role()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
